/* SHIFTRECORD */
export const SHIFTRECORD_LIST = 'SHIFTRECORD_LIST';
export const SHIFTRECORD_LIST_SUCCESS = 'SHIFTRECORD_LIST_SUCCESS';
export const SHIFTRECORD_LIST_FAILED = 'SHIFTRECORD_LIST_FAILED';
export const SHIFTRECORD_VIEW = 'SHIFTRECORD_VIEW';
export const SHIFTRECORD_VIEW_SUCCESS = 'SHIFTRECORD_VIEW_SUCCESS';
export const SHIFTRECORD_VIEW_FAILED = 'SHIFTRECORD_VIEW_FAILED';

